import {
  AirportIcon,
  EducationIcon,
  LandmarkIcon,
  HealthcareIcon,
  ShoppingCenterIcon,
  ParkIcon,
  CitySkyline,
  Forest,
  Garden,
  GolfCourse,
  Lake,
  Mountain,
  Park,
  River,
  Sea,
  Valley,
} from "../assets";

export const facilities = [
  { label: "Swimming Pool", id: 17 },
  { label: "Gym/Fitness Center", id: 18 },
  { label: "Spa/Hot Tub", id: 19 },
  { label: "Sauna", id: 20 },
  { label: "Tennis Court", id: 21 },
  { label: "Basketball Court", id: 22 },
  { label: "Golf Course", id: 23 },
  { label: "Children's Playground", id: 24 },
  { label: "Clubhouse", id: 25 },
  { label: "Gated Community", id: 26 },
  { label: "Carport", id: 27 },
  { label: "On-Site Parking", id: 28 },
  { label: "In-Unit Laundry", id: 29 },
  { label: "Pet-Friendly Facilities", id: 30 },
  { label: "Dog Park", id: 31 },
  { label: "Barbecue Area", id: 32 },
  { label: "Rooftop Deck", id: 33 },
  { label: "High-speed Internet", id: 34 },
  { label: "Business Center", id: 35 },
  { label: "Elevator", id: 36 },
  { label: "Smart Home Technology", id: 37 },
  { label: "Jacuzzi", id: 38 },
  { label: "Library", id: 39 },
  { label: "Wine Cellar", id: 40 },
  { label: "Breakfast Bar", id: 41 },
  { label: "Stainless Steel Appliances", id: 42 },
  { label: "Granite/Quartz Countertops", id: 43 },
  { label: "Concierge Service", id: 44 },
  { label: "24-hour Security", id: 45 },
  { label: "Satellite or Cable TV", id: 46 },
  { label: "Walk-in Closet", id: 47 },
  { label: "En-suite Bathroom", id: 48 },
  { label: "Solar Panels", id: 49 },
  { label: "Backup Generator", id: 50 },
  { label: "Electric Car Charging Station", id: 51 },
  { label: "Boat Dock", id: 52 },
  { label: "Private Beach Access", id: 53 },
  { label: "Storage Units", id: 54 },
  { label: "Bicycle Storage", id: 55 },
  { label: "Facilities for Disabled", id: 56 },
];

export const rooms = [
  { label: "Drawing Room", id: 9 },
  { label: "Dining Room", id: 10 },
  { label: "Study Room", id: 11 },
  { label: "Media Room/Theatre", id: 12 },
  { label: "Conference Room", id: 13 },
  { label: "Lounge or Sitting Room", id: 14 },
  { label: "Laundry Room", id: 15 },
  { label: "Game Room", id: 16 },
];

export const locationTypes = [
  { id: 1, name: "Healthcare", icon: HealthcareIcon },
  { id: 2, name: "Shopping Centers", icon: ShoppingCenterIcon },
  { id: 3, name: "Education", icon: EducationIcon },
  { id: 4, name: "Airport", icon: AirportIcon },
  { id: 5, name: "Landmarks", icon: LandmarkIcon },
  { id: 6, name: "Parks", icon: ParkIcon },
];

export const mainFeatures = [
  { label: "Air Conditioning", id: 1 },
  { label: "Central Heating", id: 2 },
  { label: "Balcon/Patio", id: 3 },
  { label: "Fireplace", id: 4 },
  { label: "Garden/Yard", id: 5 },
  { label: "Parking Garage", id: 6 },
  { label: "Cellar Basement", id: 7 },
  { label: "Water Disposal", id: 8 },
];

export const featuresTabs = [
  { title: "Main Features", id: 1 },
  { title: "Rooms", id: 2 },
  { title: "Other Facilities", id: 3 },
  { title: "Nearby Locations", id: 4 },
];

export const viewTypes = [
  {
    id: 1,
    title: "Sea",
    icon: Sea,
  },
  {
    id: 2,
    title: "Mountain",
    icon: Mountain,
  },
  {
    id: 3,
    title: "City Skyline",
    icon: CitySkyline,
  },
  {
    id: 4,
    title: "River",
    icon: River,
  },
  {
    id: 5,
    title: "Lake",
    icon: Lake,
  },
  {
    id: 6,
    title: "Garden",
    icon: Garden,
  },
  {
    id: 7,
    title: "Park",
    icon: Park,
  },
  {
    id: 8,
    title: "Forest",
    icon: Forest,
  },
  {
    id: 9,
    title: "Golf Course",
    icon: GolfCourse,
  },
  {
    id: 10,
    title: "Valley",
    icon: Valley,
  },
];

export const areaMeasurmentOptions = [
  { label: "Sq. M.", value: 1, unit: "m" },
  { label: "Sq. F.", value: 2, unit: "f" },
];

export const listingTypes = [
  { label: "Freehold", id: 1 },
  { label: "Leasehold", id: 2 },
];

export const bedroomOptions = [
  { title: "Studio", id: 0 },
  { title: "1", id: 1 },
  { title: "2", id: 2 },
  { title: "3", id: 3 },
  { title: "4", id: 4 },
  { title: "5", id: 5 },
  { title: "6", id: 6 },
  { title: "7", id: 7 },
  { title: "8", id: 8 },
  { title: "9", id: 9 },
  { title: "10+", id: 10 },
];
export const bathroomOptions = [
  { title: "1", id: 1 },
  { title: "2", id: 2 },
  { title: "3", id: 3 },
  { title: "4", id: 4 },
  { title: "5", id: 5 },
  { title: "6", id: 6 },
];
